import { useEffect, useState } from 'react';

import { Config, ConfigJSON } from './configType';

// This feels a little gross....but basically I need a way to know what environment this script was loaded in. It is
// that environment that the widgets configuration file should be loaded from. The script source should always match the
// appropriate environment, so this should always point to the right place no matter what page is loading the widgets.
// IE - if the widgets are being loaded on a D3 page they will be referenced from https://assets.nhle.com. The script
// source should reflect that, and thus we will load the widgets config from https://assets.nhle.com. If we tried to
// use window.origin, this would not work, since their origin is (obviously) not https://assets.nhle.com.
// This avoids me having to do any complex variable replacement during build/deployment (that I'm not sure is even
// possible with the way we do our deployments).
//
// Also, I have to do this here (rather than in the hook) since this document.currentScript will only actually return
// the current script if the code is run from the top level of a script.
const scriptSource = new URL((document.currentScript as HTMLScriptElement).src);

const useFetchConfig = (): Config | undefined => {
    const [config, setConfig] = useState<Config>();

    const getConfig = async () => {
        if (window.__SITE_SETTINGS__?.appId) {
            setConfig({
                appId: window.__SITE_SETTINGS__.appId,
                webAPIBaseURL: window.__SITE_SETTINGS__.webAPIBaseURL,
                translationsBaseURL: window.__SITE_SETTINGS__.translationsBaseURL,
                configBaseURL: window.__SITE_SETTINGS__.configBaseURL,
            });
        } else {
            const configResponse = await fetch(`${scriptSource.origin}/nhl_d3_widgets/config.json`);
            const configJSON: ConfigJSON = await configResponse.json();

            setConfig({
                appId: configJSON.APP_ID,
                webAPIBaseURL: configJSON.FI_UI_WEB_API_BASE_URL,
                translationsBaseURL: configJSON.FI_UI_TRANSLATIONS_BASE_URL,
                configBaseURL: configJSON.FI_UI_CONFIG_BASE_URL,
            });
        }
    };

    useEffect(() => {
        getConfig();
    }, []);

    return config;
};

export default useFetchConfig;
